import React from "react";

export default function SQL_IN() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_IN</h1>
      <p>This is the SQL_IN component generated from the SQL JSON.</p>
    </div>
  );
}
